// @import dependencies
import TextComponent from 'app_components/commons/TextComponent/TextComponent'
import React, { CSSProperties } from 'react'
// @end dependencies

// @import components
import { Modal } from 'react-bootstrap'
// @end components

// @import types
import {IFetchScheduling} from 'app_types/campus/academic/schedulingTypes'
// @end types

// @import services
// @end services

// @import hooks
// @end hooks

// @import actions
// @end actions

// @import utils
// @end utils

// @import assets
// @end assets

// @import styles
import './ModalLearningPath.scss'
import { AiOutlineCloseCircle } from 'react-icons/ai';
// @end styles

interface IModalLearningPathProps {
  learningWay: IFetchScheduling | null | 'loading'
  open: boolean
  className?: string
  classNameModal?: string
  style?: CSSProperties
  id?: string
  hideCloseButton?: boolean
  onClose?: ()=>any
}

const ModalLearningPath: React.FC<IModalLearningPathProps> = (props) => {

  const {learningWay} = props
  /**
   * @INFO Click en cerrar
   */
   const handleClickClose = () => {
    if(props.onClose){
      props.onClose()
    }
  }
  if (!learningWay || learningWay === 'loading') return <div></div>

  return(
    <Modal
      className={`modal-learning-path-container ${props.classNameModal ? props.classNameModal : ''}`}
      show={props.open}
      onHide={handleClickClose}
      centered
    >
      <Modal.Body
        style={{
          padding: '0px'
        }}
      >
        <div
          className={`modal_learning_path-layout ${props.className ? props.className : ''}`}
          style={props.style}
          id={props.id}
        >
          <div className="header-learning-path">
            <TextComponent
              type='subtitle'
              style={{
                color: 'white',
                fontSize: '1.5rem'
              }}
            >
              RUTA DE APRENDIZAJE
            </TextComponent>
            <div
              className="close-button"
              onClick={() => handleClickClose()}
            >
              <AiOutlineCloseCircle/>
            </div>
          </div>
          <div className="container-body-learning-path">
              <div>
                <TextComponent
                  type='subtitle'
                >
                  {learningWay?.program?.name}
                </TextComponent>
              </div>
              <div>
                {learningWay?.courses.map((item, index) => (
                  <ItemLearningPath
                    key={`course_${index}`}
                    item={{title: `#${index+1}`, content: item.course_name}}
                  />
                ))}
              </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

// ==========================================
// Item de la ruta
// ==========================================
interface IItemLearningPathProps {
  className?: string
  style?: CSSProperties
  id?: string
  completed?: boolean
  current?: boolean
  item: {title: string, content: string}
}

const ItemLearningPath: React.FC<IItemLearningPathProps> = (props) => {
  return(
    <div
      className={`item_learning_path-layout ${props.completed ? 'completed' : ''} ${props.current ? 'current' : ''} ${props.className ? props.className : ''}`}
      style={props.style}
      id={props.id}
    >
      <div className="container-text">
        <TextComponent
          type='text'
          style={{ color: 'var(--primary)' }}
        >
          {props.item?.content}
        </TextComponent>
      </div>
    </div>
  );
}


export default ModalLearningPath;
